var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 28V13C68 9.68629 65.3137 7 62 7H18C14.6863 7 12 9.68629 12 13V89C12 92.3137 14.6863 95 18 95H62C65.3137 95 68 92.3137 68 89V61",
    stroke: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27V14C62 13.4477 61.5523 13 61 13H19C18.4477 13 18 13.4477 18 14V82C18 82.5523 18.4477 83 19 83H61C61.5523 83 62 82.5523 62 82V60.5",
    stroke: "#039BE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 86.5,
    width: 19,
    height: 4,
    rx: 2,
    stroke: "#039BE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 27.5,
    width: 58,
    height: 33,
    rx: 1.5,
    stroke: "#039BE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 34.5,
    width: 58,
    height: 7,
    stroke: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualCard);
export default ForwardRef;